module.exports = {"420581001":"陆城街道","420581100":"红花套镇","420581101":"高坝洲镇","420581102":"聂家河镇","420581103":"松木坪镇","420581104":"枝城镇","420581105":"姚家店镇","420581106":"五眼泉镇","420581107":"王家畈镇","420581200":"潘家湾土家族乡","420581400":"松宜矿区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420581.json
// module id = 1586
// module chunks = 0